// components/ErrorPage.jsx
import { useRouteError, useNavigate } from 'react-router-dom';
import { Result, Button, Space, Typography } from 'antd';
import { HomeOutlined, ReloadOutlined, ArrowLeftOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

function ErrorPage() {
  const error = useRouteError?.() || null;
  const navigate = useNavigate();

  const getErrorConfig = () => {
    const statusCode = (error && typeof error === 'object' && 'status' in error && error.status) ? error.status : 404;
    switch (statusCode) {
      case 404:
        return {
          status: '404',
          title: 'Not Found',
          subTitle: 'Page not found!',
        };
      case 403:
        return {
          status: '403',
          title: 'Forbidden',
          subTitle: 'No access!',
        };
      case 500:
        return {
          status: '500',
          title: 'Server Error',
          subTitle: 'Server error!',
        };
      default:
        return {
          status: 'error',
          title: 'Unexpected Error',
          subTitle: 'An error occurred!',
        };
    }
  };

  const config = getErrorConfig();

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '20px'
    }}>
      <Result
        status={config.status}
        title={config.title}
        subTitle={config.subTitle}
        extra={
          <Space direction="vertical" style={{ width: '100%' }}>
            <Paragraph type="secondary" style={{ textAlign: 'center' }}>
              {config.description}
            </Paragraph>
            <Button
              type="primary"
              icon={<HomeOutlined />}
              onClick={() => navigate('/')}
              size="large"
              block
            >
              Go Home
            </Button>
            <Button
              icon={<ReloadOutlined />}
              onClick={() => window.location.reload()}
              size="large"
              block
            >
              Reload Page
            </Button>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate(-1)}
              size="large"
              block
            >
              Back
            </Button>
          </Space>
        }
      />
    </div>
  );
}

export default ErrorPage;